import { useSyncExternalStore } from 'react';
import { getBrowserTimezone } from '~/lib/DateTime';
import useCurrentBusiness from '~/lib/useCurrentBusiness.jsx';

// A client can choose to view times in a different time zone (see BookingTimeZone).
//  That choice lives outside of React so every useClientTimezone() caller stays in
//  sync no matter where it's rendered
let overrideTimezone = null;
const listeners = new Set();

function subscribe(listener) {
    listeners.add(listener);

    return () => listeners.delete(listener);
}

function getOverrideTimezone() {
    return overrideTimezone;
}

export function setClientTimezoneOverride(timezone) {
    overrideTimezone = timezone || null;
    listeners.forEach(listener => listener());
}

const useClientTimezone = () => {
    const override = useSyncExternalStore(subscribe, getOverrideTimezone);
    const business = useCurrentBusiness();

    const isFixedTimezone = business?.fixed_timezone;
    if (isFixedTimezone) {
        return business?.timezone;
    } else {
        return override || getBrowserTimezone();
    }
};

export default useClientTimezone;
